import { SpaceBetween } from "@cloudscape-design/components-themed";

import { Main } from "../components/conversion-tool/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const ConversionTool = () => {
  //権限制御
  // 権限制御
  useAuthenticationHook(PERMISSIONS.APPLY_MERCHANT_DIRECT);

  return (
    <SpaceBetween size="l">
      <Main />
    </SpaceBetween>
  );
};

export default ConversionTool;
